module.exports = __webpack_public_path__ + "static/media/logo_login.c9b712c5.png";